import Vue from 'vue'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import hljs from 'highlight.js/lib/highlight'
import javascript from 'highlight.js/lib/languages/javascript'
import 'highlight.js/styles/atom-one-light.css'

import App from './App.vue'

hljs.registerLanguage('javascript', javascript)

Vue.directive('hljs', {
    deep: true,
    bind (el, binding) {
        // on first bind, highlight all targets
        let targets = el.querySelectorAll('code')
        targets.forEach((target) => {
            // if a value is directly assigned to the directive, use this
            // instead of the element content.
            if (binding.value) {
                target.textContent = binding.value
            }
            hljs.highlightBlock(target)
        })
    },
    componentUpdated (el, binding) {
        // after an update, re-fill the content and then highlight
        let targets = el.querySelectorAll('code')
        targets.forEach((target) => {
            if (binding.value) {
                target.textContent = binding.value
                hljs.highlightBlock(target)
            }
        })
    },
})

Vue.use(Buefy)

Vue.config.productionTip = false

new Vue({
    render: h => h(App),
}).$mount('#app')
